module.exports = __webpack_public_path__ + "static/media/chevron_left.d545523b.svg";